import { ModelsCarsDto, TableModelDataDtoToTableModelData, } from '../../../../mappers/Models/models';
import { getCurrentGroupId } from '../../../../utils/functions';
import { api } from '../../api';
export const ModelsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getModelTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Modelos/${getCurrentGroupId()}`,
                params: {
                    busca: params.term || null,
                    quantidade: params.quantity || 5,
                    pagina: params.page || 1,
                    colunaOrdenacao: params.sorting?.column,
                    direcaoOrdenacao: params.sorting?.direction,
                },
            }),
            transformResponse: (response) => TableModelDataDtoToTableModelData(response),
        }),
        getModelsCars: builder.query({
            query: () => ({
                method: 'get',
                url: `api/Frota/Modelos/Indicadores/${getCurrentGroupId()}`,
            }),
            transformResponse: (response) => ModelsCarsDto(response),
        }),
    }),
});
export const { useGetModelsCarsQuery, useLazyGetModelsCarsQuery, useGetModelTableDataQuery, useLazyGetModelTableDataQuery, } = ModelsApi;
